var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-500 text-white padding-1 margin-bottom-1"},[_c('p',[_vm._t("info-box",[_vm._v(" default ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }